import { useQuery } from 'react-query';
import { getWithdrawRequest, IWithdrawRequestParams } from '../api/withdraw';
import { IWithdrawRequest } from '../types/IWithdrawRequest';
import { QueryKeys } from '../constants';

interface IWithdrawRequestResponse {
    withdrawRequestData: IWithdrawRequest | null;
    isLoading: boolean;
}

export function useGetWithdrawRequest(params: IWithdrawRequestParams): IWithdrawRequestResponse {
    const { data: withdrawRequestData, isLoading } = useQuery(
        [QueryKeys.getWithdrawRequest, params.id],
        () => getWithdrawRequest(params),
        {
            retry: false,
            staleTime: Infinity,
            cacheTime: 100,
        }
    );

    return {
        withdrawRequestData: withdrawRequestData ?? null,
        isLoading,
    };
}
